import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Dropdown } from 'react-bootstrap';
import GroupEmployeeEdit from "./GroupEmployeeEditModal";
import { employeesService } from "services";
import { showModal, hideModal } from "actions/modalActions";
import { FiPlus, FiMoreHorizontal } from "react-icons/fi";
import { EmployeeLink } from "components/Employees/EmployeeEditDrawer";
import Avatar from 'components/Avatar';
import { withTranslation } from 'react-i18next';


class GroupEmployees extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openNewEmployeesGroupModal = this.openNewEmployeesGroupModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewEmployeesGroupModal() {
		const { group, getGroupEmployees } = this.props;

		this.props.showModal(
			{
				open: true,
				title: this.props.t('groups.employees.addEmployees'),
				style: { width: "400px" },
				content: (
					<GroupEmployeeEdit handleClose={this.closeModal} group={group} getGroupEmployees={getGroupEmployees} />
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditEmployeeGroupModal(group_employee, employee_id) {
		const { group, getGroupEmployees } = this.props;

		group_employee.employee_id = employee_id;

		this.props.showModal({
			open: true,
			title: this.props.t('groups.employees.editAssignment'),
			style: { width: '400px' },
			content: <GroupEmployeeEdit group_employee={group_employee} group={group} getGroupEmployees={getGroupEmployees} handleClose={this.closeModal} />,
			closeModal: this.closeModal
		}, 'edit')
	}

	openDeleteGroupEmployeeModal(groupEmployeeId, employeeId) {
		this.props.showModal(
			{
				open: true,
				style: { width: "350px" },
				title: this.props.t('groups.employees.deleteEmployee'),
				message: this.props.t('groups.employees.deleteConfirmation'),
				deleteAction: () => this.confirmDelete(groupEmployeeId, employeeId),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	openAlertModal(message) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('groups.deleteError'),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	confirmDelete = async (groupEmployeeId, employeeId) => {
		const groupId = this.props.group.id;

		const response = await employeesService.removeGroup(employeeId, groupEmployeeId);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		} else {
			this.props.getGroupEmployees(); // TODO provar
			this.closeModal();
		}
	};

	getEmptyRow = () => {
		return (
			<tr>
				<td className="no-result" colSpan={4}>
					{this.props.t('groups.employees.noEmployees')}
				</td>
			</tr>
		);
	}

	getRows = () => this.props.group_employees.map((employee) => {
		const group_employee = employee.employee_with_group;
		const today = moment().startOf('day');
		const belongsToThisGroup = group_employee.group &&
			Number(group_employee.group.id) === Number(this.props.group.id);
		const assignmentIsScheduled = belongsToThisGroup && group_employee.start_day &&
			moment(group_employee.start_day).isAfter(today, 'day');
		const assignmentHasEnded = group_employee.end_day &&
			moment(group_employee.end_day).isBefore(today, 'day');
		const isHistorical = !belongsToThisGroup || assignmentHasEnded;
		const assignmentStatus = assignmentIsScheduled
			? 'scheduled'
			: isHistorical
				? 'historical'
				: null;

		return (
			<tr
				key={employee.id}
				className={assignmentStatus ? 'group-employee-inactive' : undefined}
			>
				<td>
					<Avatar userId={employee.id} className="avatar-sm" alt={employee.name} />

					<EmployeeLink
						className="table-link"
						employee={employee}
					>
						{employee.name} {employee.surname}
					</EmployeeLink>
					{assignmentStatus && (
						<span className={`group-employee-status group-employee-status--${assignmentStatus}`}>
							{this.props.t(`groups.employees.${assignmentStatus}`)}
						</span>
					)}
				</td>
				<td>
					{moment(group_employee.start_day).format("DD/MM/YY")}
				</td>
				<td>
					{group_employee.end_day ? moment(group_employee.end_day).format("DD/MM/YY") : "-"}
				</td>
				<td className="td-actions">
					<Dropdown>
						<Dropdown.Toggle variant="action"><FiMoreHorizontal /></Dropdown.Toggle>
						<Dropdown.Menu>
							<Dropdown.Item as="button" onClick={() => this.openEditEmployeeGroupModal(group_employee, employee.id)}>{this.props.t('groups.employees.editAssignment')}</Dropdown.Item>
							<Dropdown.Item as="button" onClick={() => this.openDeleteGroupEmployeeModal(group_employee.id, employee.id)}>{this.props.t('common.delete')}</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</td>
			</tr>
		)
	});

	getContent = () => {
		const { group_employees } = this.props;
		if (group_employees) {
			return (
				<table className="table table-groups table-employees-in-group table-zebra-reverse">
					<thead>
						<tr>
							<th>{this.props.t('groups.employees.columnEmployee')}</th>
							<th>{this.props.t('groups.employees.columnStart')}</th>
							<th>{this.props.t('groups.employees.columnEnd')}</th>
							<th className="td-actions">
								<button
									type="button"
									title={this.props.t('groups.employees.addEmployeesTitle')}
									onClick={this.openNewEmployeesGroupModal}
									className="btn btn-new"
								>
									<FiPlus />
								</button>
							</th>
						</tr>
					</thead>
					<tbody>
						{group_employees.length === 0 ?
							this.getEmptyRow()
							:
							this.getRows()
						}
					</tbody>
				</table>
			);
		}
	}
	render() {
		return (
			<>
				{this.getContent()}
			</>
		)
	}
}


const mapStateToProps = (reducers) => {
	return {
		...reducers.groupsReducer,
		...reducers.employeesReducer,
		user: reducers.authReducer.user,
	};
};


const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GroupEmployees));
